import type { StateCreator, StoreApi, UseBoundStore } from 'zustand';

// define the slice
export enum ProgressBarStepId {
  /** Select email plan (lite, standard, premium) */
  SELECT_PLAN = 'select-plan',
  /** Select add-ons */
  ADD_ONS = 'add-ons',
  /** Checkout (all flows) */
  CHECKOUT = 'checkout',
  /** Payflow, select payment plan */
  PAYMENT_PLAN = 'payment-plan-and-discounts',
  /** "Change payment plan" flow, select payment plan */
  PAYMENT_PLAN_SELECT = 'payment-plan-select',
}

export interface IPayflowProgressBarSlice {
  isProgressBarHidden: boolean;
  activeStepId: ProgressBarStepId | null;
}

export const createPayflowProgressBarSliceDefaultValues = (): IPayflowProgressBarSlice => ({
  isProgressBarHidden: false,
  activeStepId: null,
});

// create the slice helpers
export const createPayflowProgressBarSlice: StateCreator<IPayflowProgressBarSlice> = () =>
  createPayflowProgressBarSliceDefaultValues();

export type ProgressBarPageStore = UseBoundStore<StoreApi<IPayflowProgressBarSlice>>;

// create the hooks helpers
export const createPayflowProgressBarHooks = (pageStore: ProgressBarPageStore) => {
  return {
    useIsHidden: () => pageStore((state) => state.isProgressBarHidden),
    useActiveStepId: () => pageStore((state) => state.activeStepId),
  };
};

export type PayflowProgressBarHooks = ReturnType<typeof createPayflowProgressBarHooks>;
